import { FC } from 'react';
import { EnumSelectField } from '@mews-commander/form';
import { PromotedServiceAssignmentUnitCountLimit } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { lt } from '@mews/framework';
import { FormFields } from '../../../schema';

export const PromotionLimitField: FC = () => (
    <EnumSelectField
        label={lt(TextKey.PromotedServiceAssignmentUnitCountLimit)}
        enumClass={PromotedServiceAssignmentUnitCountLimit}
        name={FormFields.UnitCountLimit}
        enumPrefix="PromotedServiceAssignmentUnitCountLimit"
        showEmptyValue={false}
        required
    />
);
